import axios from "axios"

import CisCompetitionService from "@/services/cis-competition.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetShareofSearch {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = en_dt

        this.majorClsList = []
        this.brandList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const firstClasses = await CisCompetitionService.listFirstClass({
            ctgSq: this.sel_category
        }, source);

        if (firstClasses.data.success)
            this.majorClsList = firstClasses.data.data
    }

    async getDataDonutBar(majorCls){     
        var resBrnShareDonutData = [];
        var resBrnShareBarData = [];

        const response = await CisCompetitionService.getCompetitionDataDonutBar({
            startDate : this.st_dt,
            endDate : this.en_dt,
            ctgSq : this.sel_category,
            fclsSq : majorCls,
            fattrSq : null,
            colNm: null,
            sattrNm : null
        }, source);

        if (response && response.status === 200) {
            // total freq update
            var totalFreq = response.data.data.donutData[0].totalFreq
            
            // donut chart update
            var donutChartData = [response.data.data.donutData[0].brandedFreq, response.data.data.donutData[0].nonbrandedFreq]

            for (const idx in donutChartData) {
                if (idx == 0)
                    resBrnShareDonutData.push({
                        keyword: 'BRANDED',
                        freq: donutChartData[idx],
                        rate: totalFreq == 0 ? 0 : donutChartData[idx] / totalFreq * 100
                    }); 
                else
                    resBrnShareDonutData.push({
                        keyword: 'NONBRANDED',
                        freq: donutChartData[idx],
                        rate: totalFreq == 0 ? 0 : donutChartData[idx] / totalFreq * 100
                    }); 
            }

            // bar chart update
            var barChartData = []
            var barChartCategory = []
            var barChartFreq = []

            this.brandList = []
            
            for(const item of response.data.data.barData) {
                barChartData.push(item.rate)
                barChartCategory.push(item.brand)
                barChartFreq.push(item.freq)

                this.brandList.push(item.brand)
            }

            for (const idx in barChartData) {
                resBrnShareBarData.push({
                    keyword: barChartCategory[idx],
                    freq: barChartFreq[idx],
                    rate: barChartData[idx]
                }); 
            }
        }

        return {'donut': resBrnShareDonutData, 'bar': resBrnShareBarData}
    }

    async getDataLine(majorCls){
        var resBrnShareTrkData = [];
        var resBrnShareTrkCat = [];
      
        if(this.brandList.length > 0)
        {
            const response = await CisCompetitionService.getCompetitionDataLine({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                fclsSq : majorCls,
                fattrSq : null,
                colNm: null,
                sattrNm : null,
                brandList : this.brandList
            }, source);

            if (response && response.status === 200) {
                var lineChartData = []

                for(const item of response.data.data) {
                    lineChartData.push({
                        brand: item.brand,
                        type: 'line',
                        data: item.rate.split(','),
                        description: item.freq.split(','),
                        hidden: true
                    })

                    if (resBrnShareTrkCat.length == 0) 
                        resBrnShareTrkCat = item.date.split(',')
                } 

                for (const idx in lineChartData) {
                    resBrnShareTrkData.push({
                        keyword: lineChartData[idx].brand,
                        freq: lineChartData[idx].description,
                        rate: lineChartData[idx].data
                    }); 
                }
            }           
        }

        return { 'data': resBrnShareTrkData, 'cat': resBrnShareTrkCat }
    }

    async getDataTable(majorCls){
        var resSearchKeywordData = []

        if(this.brandList.length > 0)
        {
            const response = await CisCompetitionService.getCompetitionDataTableExp({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                fclsSq : majorCls,
                fattrSq : null,
                colNm: null,
                sattrNm : null,
                brandList : this.brandList
            }, source);

            if (response && response.status === 200) {
                resSearchKeywordData = response.data.data
            }
        }

        return resSearchKeywordData
    }

    async run() {
        var resDataset = []; 

        var donutBarChartData = await this.getDataDonutBar(null)

        resDataset.push({'sheet_type': 0, 'sheet_nm': '브랜드 vs. 논브랜드_전체', 'data': donutBarChartData.donut, 'cat': ['검색량', '비율']})
        resDataset.push({'sheet_type': 0, 'sheet_nm': '브랜드 점유율_전체', 'data': donutBarChartData.bar, 'cat': ['검색량', '비율']})

        var lineChartData = await this.getDataLine(null)

        resDataset.push({'sheet_type': 1, 'sheet_nm': '브랜드 점유율 트래킹_전체', 'data': lineChartData.data, 'cat': lineChartData.cat})

        var tableData = await this.getDataTable(null)

        resDataset.push({'sheet_type': 2, 'sheet_nm': '검색량 상위 키워드_전체', 'data': tableData, 'cat': ['검색량', '브랜드']})

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                donutBarChartData = await this.getDataDonutBar(major.id)

                resDataset.push({'sheet_type': 0, 'sheet_nm': `브랜드 vs. 논브랜드_${major.title}`, 'data': donutBarChartData.donut, 'cat': ['검색량', '비율']})
                resDataset.push({'sheet_type': 0, 'sheet_nm': `브랜드 점유율_${major.title}`, 'data': donutBarChartData.bar, 'cat': ['검색량', '비율']})

                lineChartData = await this.getDataLine(major.id)

                resDataset.push({'sheet_type': 1, 'sheet_nm': `브랜드 점유율 트래킹_${major.title}`, 'data': lineChartData.data, 'cat': lineChartData.cat})

                tableData = await this.getDataTable(major.id)

                resDataset.push({'sheet_type': 2, 'sheet_nm': `검색량 상위 키워드_${major.title}`, 'data': tableData, 'cat': ['검색량', '브랜드']})
            }
        }

        return resDataset
    }
}